import classNames from "classnames";
import React from "react";

import { useSelector } from "../../../utils/hooks";
import strings from "../../../utils/strings";
import "./SubscriptionDetails.scss";

interface SubscriptionDetailsI {
	isInfoModal?: boolean;
}

const SubscriptionDetails = (props: SubscriptionDetailsI) => {
	const subscription = useSelector(
		(state) => state.popup.products.mainProduct.subscription,
	);

	const isGamePassAvailable = useSelector(
		(state) => state.popup.isGamePassAvailable,
	);


	return (
		<div>
			<div
				className={classNames({
					"addtocart-subscription-details": true,
					"info-modal": props.isInfoModal,
				})}
			>
				<div className="addtocart-subscription-details__more-info-container">
					{props.isInfoModal && (
						<div className="addtocart-subscription-details__more-info-row monthly">
							<div className="addtocart-subscription-details__more-info-text">
								<span className="addtocart-subscription-details__more-info-text-monthly-label">
									{subscription.monthlyPriceLabel}
								</span>
								<span className="addtocart-subscription-details__more-info-text-monthly-price">
									{subscription.monthlyPrice}
								</span>
							</div>
							<div className="addtocart-subscription-details__more-info-amount-monthly">
								({subscription.totalPriceLabel} {subscription.productPrice})
							</div>
						</div>
					)}
					<div className="addtocart-subscription-details__more-info-row">
						<div className="addtocart-subscription-details__more-info-text">
							{subscription.switchBy}
						</div>
						<div className="addtocart-subscription-details__more-info-amount">
							{subscription.renewalPeriod} {subscription.months}
						</div>
					</div>

					<div className="addtocart-subscription-details__more-info-row">
						<div className="addtocart-subscription-details__more-info-text">
							{subscription.moreInfoTableFirst}
						</div>
						<div className="addtocart-subscription-details__more-info-amount">
							{subscription.payToday}
						</div>
					</div>

					<div className="addtocart-subscription-details__more-info-row">
						<div className="addtocart-subscription-details__more-info-text">
							{subscription.moreInfoTableThird}
						</div>
						<div className="addtocart-subscription-details__more-info-amount">
							{subscription.subscriptionTerms.komplettPrice}
						</div>
					</div>
				</div>
				<div className="addtocart-subscription-details__more-info-rate-container">
					<div className="addtocart-subscription-details__more-info-rate-row">
						<div
							className="addtocart-subscription-details__more-info-amount"
							dangerouslySetInnerHTML={{
								__html: subscription.subscriptionTerms.termOfCreditAgreement,
							}}
						/>
						<div className="addtocart-subscription-details__more-info-rate-text">
							{subscription.doYouWantToKeepProducts}
						</div>
					</div>
				</div>

				<div className="addtocart-subscription-details__more-info-row">
					<div className="addtocart-subscription-details__more-info-text">
						<strong>{subscription.exampleCalculationLabel}</strong>
					</div>
					<div
						className="addtocart-subscription-details__more-info-amount"
						dangerouslySetInnerHTML={{
							__html: subscription.exampleCalculationText,
						}}
					/>
				</div>

				{isGamePassAvailable && (
					<div className="addtocart-subscription-details__more-info-row">
						<div
							className="addtocart-subscription-details__more-info-text"
							dangerouslySetInnerHTML={{
								__html: strings.flexWithGamePassInformation,
							}}
						/>
					</div>
				)}
			</div>
		</div>
	);
};

export default SubscriptionDetails;
